import { styled } from 'styled-components';

import { SortAndFiltersSt } from '~organisms/SortAndFiltersSection';

export const SortAndFiltersContainer = styled.div(({ theme }) => ({
  [`${SortAndFiltersSt.OpenFiltersBtn}`]: {
    color: theme.palette.erieBlack,
    fontSize: theme.typography.size16,
    border: 'unset',
    boxShadow: `0 2rem 3rem ${theme.palette.superLightGray}`,
    '&:focus': {
      outline: 'unset',
    },
    flexShrink: 0,
  },
}));
